import {
  type ConfiguratorFullResetResult,
  sendConfiguratorFullReset,
} from "~/features/configurator/common/api/configuratorCommandApi";
import type { LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";

export async function sendShaftResetConfigurator(state: LinearConfiguratorState): Promise<ConfiguratorFullResetResult> {
  const payload = await sendConfiguratorFullReset(state);
  return {
    configuration: transform(payload.data, state.type!),
    helpUrl: payload.helpUrl,
  };
}
